export const VALID_CACHE_KEY_MAP = {
  CONTRIBUTORS: "contributors",
  GLOBAL_NAV: "globalNav",
  JOBS: "jobs",
  PAGE_DATA_MAP: "pageDataMap",
  SITEMAP: "sitemap"
};

export const VALID_CACHE_KEYS = Object.values(VALID_CACHE_KEY_MAP);

export const CACHE_DIRECTORY = "tmp";
export const BUILD_DIRECTORY = "build";

export const ITEM_PREVIEW_LIST_FORMS = {
  AVATAR_CARD_MEDIUM: "Avatar Card (Medium)",
  AVATAR_CARD_SMALL: "Avatar Card (Small)",
  AVATAR_CARD_XSMALL: "Avatar Card (X-Small)",
  HORIZONTAL_FULL_WIDTH: "Horizontal (Full Width)",
  HORIZONTAL_2UP: "Horizontal (2Up)",
  HORIZONTAL_FULL_WIDTH_CONTAINED: "Horizontal, Contained (Full Width)",
  HORIZONTAL_2UP_CONTAINED: "Horizontal, Contained (2Up)",
  VERTICAL_CARD_2UP: "Vertical (2Up)",
  VERTICAL_CARD_3UP: "Vertical (3Up)",
  VERTICAL_CARD_4UP: "Vertical (4Up)",
  VERTICAL_CARD_2UP_CONTAINED: "Vertical, Contained (2Up)",
  VERTICAL_CARD_3UP_CONTAINED: "Vertical, Contained (3Up)",
  VERTICAL_CARD_4UP_CONTAINED: "Vertical, Contained (4Up)",
  TEXT_CARD_2UP: "Text-Only (2Up)",
  TEXT_CARD_3UP: "Text-Only (3Up)",
  TEXT_CARD_4UP: "Text-Only (4Up)",

  // special purpose
  RESOURCE: "Resource",
  HEADLINE: "Headline"
};

export const SENTRY_DEFAULT_SAMPLE_RATE = 0.2;

export const PRIVACY_MANDATE_REGIONS = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "EL",
  "GG",
  "HU",
  "IE",
  "IS",
  "IT",
  "LI",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "UK",
  "US-CA"
];

export const REQUIRED_COOKIES = [
  "_of", //Accepted or rejected cookies
  "__stripe_mid", //new fundraise up cookie 9/23
  "fundraiseup_session", // Fundraise Up required
  "fundraiseup_cid", // Fundrasise Up required
  "of_test", // Required for Sentry Cypress test
  "ASLBSA", // Azure Front door
  "ASLBSACORS" // Azure Front door
];

export const BREAK_POINTS = {
  sm: 360,
  md: 834,
  lg: 1366
};
